import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import '../css/Home.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faVialCircleCheck,
  faSearch,
  faBinoculars,
} from '@fortawesome/free-solid-svg-icons';

const Home = () => {
  const [showJBrowse, setShowJBrowse] = useState(false);

  const bioTools = [
    { path: "/blast", icon: faSearch, label: "BLAST", color: "#ff5733" },

    // ✅ External link (Primer3Plus)
    {
      label: "Primer Design",
      icon: faVialCircleCheck,
      color: "#FF9800",
      action: () => window.open("https://www.primer3plus.com/index.html", "_blank"),
    },

    // ✅ External link (Clustal Omega)
    {
      label: "Clustal Omega",
      icon: faSearch,
      color: "#9C27B0",
      action: () =>
        window.open("https://www.ebi.ac.uk/Tools/msa/clustalo/", "_blank"),
    },

    {
      label: "JBrowse 2",
      icon: faBinoculars,
      color: "#4CAF50",
      action: () => setShowJBrowse(true),
    },
  ];

  // --- JBrowse fullscreen ONLY (keep this) ---
  if (showJBrowse) {
    return (
      <div style={{ position: "fixed", inset: 0, backgroundColor: "#000", zIndex: 9999 }}>
        <div style={{
          background: "#1a1a1a",
          padding: "10px 20px",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}>
          <h3 style={{ color: "white" }}>🧬 JBrowse 2 Genome Viewer</h3>
          <button
            onClick={() => setShowJBrowse(false)}
            style={{
              background: "#4CAF50",
              border: "none",
              color: "white",
              padding: "8px 16px",
              borderRadius: "5px",
            }}
          >
            ⬅ Back to Home
          </button>
        </div>

        <iframe
          src="/jbrowse-data/?config=config.json"
          title="JBrowse 2"
          style={{ width: "100%", height: "100%", border: "none" }}
        />
      </div>
    );
  }

  return (
    <div
      className="home-container"
      style={{
        backgroundImage: `url(${process.env.PUBLIC_URL}/images/tefl.jpg)`,
      }}
    >
      <div className="overlay"></div>

      <div className="home-content">
        <div className="intro-container">
          <div className="marquee-message">
            Welcome to <span className="brand-name">TefDB Platform</span> – Empowering
            <span className="tef-highlight"> Teff Research</span> Worldwide 🌍
          </div>

          <div className="description-container">
            <strong><i>TefDB</i></strong> is a web‑based platform of <em>Eragrostis tef</em> specific species resource
            to enhance <strong>teff research, popularity, and global recognition</strong> with bioinformatic tools.
          </div>
        </div>

        <div className="tools-wrapper">
          <h3 className="tools-title">Bioinformatic Tools</h3>

          <div className="tools-grid">
            {bioTools.map((tool, index) =>
              tool.action ? (
                <div
                  key={index}
                  className="tool-card"
                  onClick={tool.action}
                  style={{ cursor: "pointer" }}
                >
                  <FontAwesomeIcon
                    icon={tool.icon}
                    className="tool-icon"
                    style={{ color: tool.color }}
                  />
                  <span className="tool-label">{tool.label}</span>
                </div>
              ) : (
                <Link key={index} to={tool.path} className="tool-card">
                  <FontAwesomeIcon
                    icon={tool.icon}
                    className="tool-icon"
                    style={{ color: tool.color }}
                  />
                  <span className="tool-label">{tool.label}</span>
                </Link>
              )
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Home;
